import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ width?: number }>()(
  (theme, { width = 668 }) => ({
    dialogContainer: {
      containerType: 'inline-size',
    },
    dialogPaper: {
      overflowY: 'auto',
      minHeight: 'auto',
      borderRadius: theme.tokens.radius.l,
      flexGrow: 1,
      [theme.breakpoints.up('md')]: {
        minWidth: theme.px(width),
      },

      '& > form': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      },
    },
    bottomIslandSpace: {
      marginBottom: theme.px(120),
    },
    dialogWithoutRadius: {
      borderRadius: 0,
    },
  }),
);
